import logo from "@/assets/logo.png";

const MARKETING_BASE_URL = "https://granguard.org";

export function MarketingFooter() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-6xl px-6 pb-8 pt-12 sm:px-8 sm:pt-14 lg:px-8 lg:pt-16">

        <div className="flex flex-col gap-10 md:grid md:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)] md:gap-10 lg:grid-cols-[minmax(0,320px)_minmax(0,1fr)] lg:gap-14">

          <div className="shrink-0 space-y-4 md:max-w-none lg:max-w-[320px]">
            <a href={MARKETING_BASE_URL} className="inline-flex items-center">
              <img src={logo} alt="GranGuard" className="h-auto w-32 lg:w-36" loading="lazy" />
            </a>
            <p className="text-sm font-semibold text-slate-900 leading-snug">Feel more confident in your digital life.</p>
            <p className="text-sm text-slate-500 leading-relaxed">
              GranGuard keeps families ahead of scams with expert guidance, essential tools, and support when something feels off.
            </p>
            <div className="flex flex-wrap items-center gap-4 pt-1 text-sm">
              <a href={`${MARKETING_BASE_URL}/#pricing`} className="inline-flex items-center rounded-full bg-violet-50 px-3 py-1.5 font-semibold text-violet-700 hover:bg-violet-100 transition">
                View plans
              </a>
              <a href="mailto:support@granguard.org" className="font-medium text-slate-600 hover:text-violet-700 transition">
                Talk to us
              </a>
            </div>
          </div>

          <div className="grid flex-1 grid-cols-1 gap-8 text-sm text-slate-600 sm:grid-cols-2 md:grid-cols-3 md:gap-6 lg:gap-10">
            <div className="space-y-3">
              <p className="text-xs font-semibold uppercase tracking-[0.08em] text-slate-900">Product</p>
              <div className="grid gap-2">
                <a href={`${MARKETING_BASE_URL}/features`} className="hover:text-violet-700 transition-colors">Features</a>
                <a href={`${MARKETING_BASE_URL}/#pricing`} className="hover:text-violet-700 transition-colors">Pricing</a>
                <a href={`${MARKETING_BASE_URL}/about`} className="hover:text-violet-700 transition-colors">About</a>
                <a href={`${MARKETING_BASE_URL}/press`} className="hover:text-violet-700 transition-colors">Press</a>
                <a href={`${MARKETING_BASE_URL}/blog`} className="hover:text-violet-700 transition-colors">Blog</a>
              </div>
            </div>

            <div className="space-y-3">
              <p className="text-xs font-semibold uppercase tracking-[0.08em] text-slate-900">Support</p>
              <div className="grid gap-2">
                <a href={`${MARKETING_BASE_URL}/#faq`} className="hover:text-violet-700 transition-colors">FAQ</a>
                <a href="mailto:support@granguard.org" className="hover:text-violet-700 transition-colors">Email support</a>
                <a href={`${MARKETING_BASE_URL}/contact`} className="hover:text-violet-700 transition-colors">Contact</a>
              </div>
            </div>

            <div className="space-y-3">
              <p className="text-xs font-semibold uppercase tracking-[0.08em] text-slate-900">Policies</p>
              <div className="grid gap-2">
                <a href={`${MARKETING_BASE_URL}/policies#terms`} className="hover:text-violet-700 transition-colors">Terms &amp; Conditions</a>
                <a href={`${MARKETING_BASE_URL}/policies#cookies`} className="hover:text-violet-700 transition-colors">Cookie Policy</a>
                <a href={`${MARKETING_BASE_URL}/policies#privacy`} className="hover:text-violet-700 transition-colors">Privacy Policy</a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-slate-200 pt-6 text-sm text-slate-400 sm:mt-10 sm:flex-row sm:items-center sm:justify-between">
          <p className="leading-relaxed">© {new Date().getFullYear()} GranGuard. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <a href={MARKETING_BASE_URL} className="hover:text-violet-700 transition-colors">Home</a>
            <a href={`${MARKETING_BASE_URL}/#pricing`} className="hover:text-violet-700 transition-colors">Plans</a>
            <a href={`${MARKETING_BASE_URL}/press`} className="hover:text-violet-700 transition-colors">Press</a>
            <a href="mailto:support@granguard.org" className="hover:text-violet-700 transition-colors">support@granguard.org</a>
          </div>
        </div>
      </div>
    </footer>
  );
}



